import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VClass, LezRule } from 'src/app/interfaces/index';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';

@Injectable()
export class VClassService {
  constructor(private http: HttpClient, private apiService: ApiService) {}

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.boapi);
  }

  public getClass(npId: string): Observable<VClass> {
    return this.http.get<VClass>(`${this.url}` + '/v1/vehicles/class/' + npId);
  }
  
  public getRules(npId: string, clientdb: string, ruleDate:string): Observable<LezRule> {
    let url = `${this.url}/v1/vehicles/lez/${clientdb}/${npId}/?date=${ruleDate}`;
    
    if (clientdb == "KMT") 
       url = `${this.url}v1/vehicles/rules/${clientdb}/${npId}/?date=${ruleDate}`;
    return this.http.get<LezRule>(url);
  }
}